import { SideBySideData } from '../../../../types';
import { LivePreview } from './LivePreview';

interface PreviewModalProps {
    data: SideBySideData;
    isOpen: boolean;
    onClose: () => void;
    onSwap?: () => void;
    activeCard?: 1 | 2 | null;
}

export const PreviewModal = ({ data, isOpen, onClose, onSwap, activeCard }: PreviewModalProps) => {
    if (!isOpen) return null;

    return (
        <div className="preview-modal-overlay" onClick={onClose}>
            <div className="preview-modal" onClick={(e) => e.stopPropagation()}>
                <div className="preview-modal-header">
                    <h3>Preview</h3>
                    <button className="close-btn" onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className="preview-modal-content">
                    <LivePreview
                        data={data}
                        showSectionTitle={false}
                        onSwap={onSwap}
                        interactive={false}
                        activeCard={activeCard}
                        className="large"
                    />
                </div>
            </div>
        </div>
    );
};
